import { render, staticRenderFns } from "./SortPage.vue?vue&type=template&id=4254a51a&scoped=true"
import script from "./SortPage.vue?vue&type=script&lang=js"
export * from "./SortPage.vue?vue&type=script&lang=js"
import style0 from "./SortPage.vue?vue&type=style&index=0&id=4254a51a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4254a51a",
  null
  
)

export default component.exports